import React, {useState} from 'react';
import AuthenticationInput from "../../Utils/Inputs/AuthenticationInput/AuthenticationInput";
import Buttons, {EnumColors} from "../../Utils/Buttons/Buttons/Buttons";
import {UIText} from "../../../enums/UIText/UIText";
import {getTextByLanguage} from "../../../enums/utils/getTextByLanguage";
import {useAppSelector} from "../../../hooks/redux";
import {getLanguage} from "../../../store/selectors/appSelector";
import styles from './Authentication_RecoveryPassword.module.css'
import {authApi} from "../../../api/authApi";
import {toast} from "react-toastify";
import {EnumAuthenticationMode} from "../Authentication";

interface IProps {
    setAuthenticationMode: (recoveryPasswordSuccess: EnumAuthenticationMode.recoveryPasswordSuccess) => void
}

const AuthenticationRecoveryPassword = ({setAuthenticationMode} : IProps) => {

    const language = useAppSelector(getLanguage)

    const [email, setEmail] = useState<string>('')

    const [isFetching, setIsFetching] = useState<boolean>(false)

    const sendRecoveryRequestHandler = async () => {
        setIsFetching(true)
        try {
            if (email) {
                await authApi.sendRecoveryRequest(email)
                toast.success('Письмо было отправлено!')
                setIsFetching(false)
                setAuthenticationMode(EnumAuthenticationMode.recoveryPasswordSuccess)
            } else {
                toast.warning('Введите эл. почту')
                setIsFetching(false)
            }

        } catch (error) {
            console.log(error)
            // @ts-ignore
            toast.error(error.response.data.message)
            setIsFetching(false)
        }
    }

    return (
        <div className={styles.wrapper}>
            <AuthenticationInput onChange={(e) => setEmail(String(e.target.value))} type={'email'}
                                placeholder={getTextByLanguage(UIText.authentication.inputsPlaceholders.email, language)}/>
            <Buttons
                loading={isFetching} disabled={isFetching} className={styles.button} color={EnumColors.white}
                onClick={sendRecoveryRequestHandler}>{getTextByLanguage(UIText.authentication.buttons.restore, language)}</Buttons>
        </div>
    );
};

export default AuthenticationRecoveryPassword;